import {useEffect, useState} from 'react';
import {CurriculumTypeEnum} from '@PikaDoApp/npm-pikado-logic';
import {Button, Col, Input, Row, Select, Typography} from 'antd';
import {useHistory, useLocation} from 'react-router-dom';
import {Level, Curriculum, Program, Language} from '../../graphql/API';
import {LevelsService} from '../Level/LevelsService';
import {CurriculumsService} from './CurriculumsService';
import {ProgramsNewService} from '../Program';
import {PlacementTestsService} from '../PlacementTest/PlacementTestsService';

const levelService = new LevelsService();
const curriculumsService = new CurriculumsService();
const programsService = new ProgramsNewService();
const placementTestsService = new PlacementTestsService();

export const CurriculumCreate = () => {
  const history = useHistory();

  const {Title, Text} = Typography;

  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const location: {
    state: any;
    hash: any;
    search: any;
    pathname: any;
  } = useLocation();

  const [curriculum, setCurriculum] = useState<Curriculum>();
  const [programs, setPrograms] = useState<Array<Program> | []>([]);
  const [lanuages, setLanguages] = useState<Array<Language> | []>([]);

  const [selectedProgramId, setSelectedProgramId] = useState<string>();
  const [selectedLanguageId, setSelectedLanguageId] = useState<string>();
  const [selectedLevelIds, setSelectedLevelIds] = useState<string[]>([]);
  const [selectedPlacementTestIds, setSelectedPlacementTestIds] = useState<
    string[]
  >([]);
  const [selectedCurriculumType, setSelectedCurriculumType] =
    useState<string>();

  const [levels, setLevels] = useState<Array<Level> | []>([]);
  const [placementTests, setPlacementTests] = useState<Array<any> | []>([]);

  useEffect(() => {
    levelService
      .getLevels()
      .then(lvls => {
        setLevels(lvls);
      })
      .catch(error => {
        setIsError(true);
        console.log('Error ->', error);
      });

    programsService
      .getNewPrograms()
      .then(resp => {
        setIsLoading(false);
        // console.log('getProgramsr response ->->', resp);
        setPrograms(resp);
      })
      .catch(error => {
        setIsError(true);
        console.log('Error ->', error);
      });

    placementTestsService
      .getPlacementTests(1, 100) // Fetch first 100 placement tests
      .then(resp => {
        setIsLoading(false);
        console.log('Placement tests response ->', resp);
        setPlacementTests(resp.items || []);
      })
      .catch(error => {
        setIsError(true);
        console.log('Error fetching placement tests ->', error);
      });
  }, []);

  const onChange = (prop: any, value: any) => {
    console.log('curre_curriculum', curriculum);
    //@ts-ignore
    setCurriculum({...curriculum, [prop]: value});
  };

  console.log('curriculum', curriculum);

  return (
    <div style={{padding: 10}}>
      <Title style={{textAlign: 'center'}}>Create Curriculum</Title>
      <>
        <Row>
          <Col span={12}>
            <div style={{margin: 20}}>
              <Text style={{display: 'block'}} strong={true}>
                Curriculum Name
              </Text>
              <Input
                placeholder={'Enter Curriculum Name'}
                onChange={e => onChange('name', e.target.value)}
                value={curriculum?.name}
              />
            </div>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <div style={{margin: 20}}>
              <Text style={{display: 'block'}} strong={true}>
                Curriculum Type *
              </Text>
              <Select
                value={selectedCurriculumType}
                showSearch
                style={{width: '100%'}}
                placeholder="Select Curriculum Type"
                optionFilterProp="children"
                onChange={type => {
                  setSelectedCurriculumType(type);
                  onChange('type', type);
                }}>
                {Object.values(CurriculumTypeEnum).map(type => (
                  <Select.Option key={type} value={type}>
                    {type}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <div style={{margin: 20}}>
              <Text style={{display: 'block'}} strong={true}>
                Plan Period
              </Text>
              <Input
                placeholder={'Enter plan period in Days'}
                onChange={e => onChange('totalPlanPeriod', e.target.value)}
                value={curriculum?.totalPlanPeriod}
                type="number"
              />
            </div>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <div style={{margin: 20}}>
              <Text style={{display: 'block'}} strong={true}>
                Select Curriculum Program *
              </Text>
              <Select
                value={selectedProgramId}
                showSearch
                style={{width: '100%'}}
                placeholder="Select a Program"
                optionFilterProp="children"
                onChange={programId => setSelectedProgramId(programId)}>
                {programs?.map(prgm => (
                  <Select.Option key={prgm.id} value={prgm.id!}>
                    {prgm.name}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <div style={{margin: 20}}>
              <Text style={{display: 'block'}} strong={true}>
                Select Curriculum Levels *
              </Text>
              <Select
                mode="multiple"
                value={selectedLevelIds}
                showSearch
                style={{width: '100%'}}
                placeholder="Select levels"
                optionFilterProp="children"
                onChange={levelIds => setSelectedLevelIds(levelIds)}>
                {levels?.map(level => (
                  <Select.Option key={level.id} value={level.id}>
                    {level.name}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <div style={{margin: 20}}>
              <Text style={{display: 'block'}} strong={true}>
                Select Curriculum Language *
              </Text>
              <Select
                value={selectedLanguageId}
                showSearch
                style={{width: '100%'}}
                placeholder="Select a language"
                optionFilterProp="children"
                onChange={lngId => setSelectedLanguageId(lngId)}>
                {lanuages?.map((lng: Language) => (
                  <Select.Option key={lng.id} value={lng.id!}>
                    {lng.language}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <div style={{margin: 20}}>
              <Text style={{display: 'block'}} strong={true}>
                Select Placement Tests
              </Text>
              <div style={{display: 'flex', gap: 10}}>
                <Select
                  mode="multiple"
                  value={selectedPlacementTestIds}
                  showSearch
                  style={{flex: 1}}
                  placeholder="Select placement tests"
                  optionFilterProp="children"
                  onChange={testIds => setSelectedPlacementTestIds(testIds)}>
                  {placementTests?.map(test => (
                    <Select.Option
                      key={test._id || test.id}
                      value={test._id || test.id}>
                      {test.name}
                    </Select.Option>
                  ))}
                </Select>
                <Button
                  onClick={() => history.push('/placement-tests/create')}
                  type="default">
                  create
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </>

      <Button
        onClick={async () => {
          console.log('INCREATEEET');
          if (
            curriculum &&
            curriculum?.name &&
            curriculum?.totalPlanPeriod &&
            selectedCurriculumType &&
            selectedProgramId &&
            selectedLanguageId &&
            selectedLevelIds &&
            selectedLevelIds.length > 0
          ) {
            console.log('INCREATEEET_ID', curriculum);

            setIsLoading(true);

            // NEW IMPLEMENTATION - Using @PikaDoApp/npm-pikado-logic package
            await curriculumsService
              .createNewCurriculum(
                curriculum,
                selectedProgramId,
                selectedLanguageId,
                selectedLevelIds,
                selectedCurriculumType as CurriculumTypeEnum,
                selectedPlacementTestIds,
              )
              .then((e: any) => {
                alert('curriculum Created');
                history.push('/curriculums');
              })
              .catch(err => {
                alert('error curriculum' + JSON.stringify(err));

                console.log('upadate errpr curriculum->', err);
              })
              .finally(() => {
                setIsLoading(false);
              });
          } else {
            alert(
              'Please fill in all required fields including at least one level',
            );
          }
        }}>
        Create
      </Button>
    </div>
  );
};
